/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { observable, action } from "mobx";
import { isCurrentDeviceMobile, isCurrentDeviceTablet } from "dc-preview-utils/src/Utils/DeviceUtils";
import { isBoolean } from "utils/lodashUtils";

class AppUIState {
  // Disabling ImmersiveMode by default.
  @observable isImmersiveModeEnabled;
  @observable isImmersiveMode;
  @observable shouldRenderPageShadows;
  @observable scrollbarSize;
  @observable addressBarHeight;

  constructor() {
    this.init();
  }

  initStore(docApi, stores) {
    if (docApi) {
      this.docApi = docApi;
    }
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  init() {
    this.isImmersiveModeEnabled = false;
    this.isImmersiveMode = false;
    this.shouldRenderPageShadows = false;
    this.scrollbarSize = 0;
    this.addressBarHeight = 0;

    // non-observables
    this.appContext = ""; // appContext is the context passed to preview dropin in the config props.
  }

  @action
  setAppContext(context) {
    this.appContext = context;
  }

  @action
  setScrollbarSize(scrollbarSize) {
    this.scrollbarSize = scrollbarSize;
  }

  @action
  setImmersiveMode(value = false) {
    this.isImmersiveMode = value;
  }

  @action
  setAddressBarHeight(value) {
    if ((isCurrentDeviceMobile() || isCurrentDeviceTablet()) && value >= 0) {
      this.addressBarHeight = value;
    }
  }

  @action
  setShouldRenderPageShadows(shouldRenderPageShadows) {
    if (isBoolean(shouldRenderPageShadows)) {
      this.shouldRenderPageShadows = shouldRenderPageShadows;
    }
  }
}

export { AppUIState };
